// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1o-tE","select":"Header_select__3g4Hp","clinic":"Header_clinic__sq3Ch"};